import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useHandleActionItem } from "../../../hooks/useHandleActionItem.js";
import InputText from "../../../components/forms/InputText.jsx";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

function VehiclesDetails() {
	const location = useLocation();
	const navigate = useNavigate();
	const locationType = location.state?.type || "";
	const data = useMemo(() => location.state?.data || [], [location.state?.data]);

	const [vehicle, setVehicle] = useState({
		marca: "",
		modelo: "",
		año: new Date().getFullYear(),
		precioLista: 0,
		tipo: "",
		transmision: "",
		combustible: "",
		motor: "",
		traccion: "",
		urlFoto: "",
		coloresDisponibles: "",
		caracteristicasDestacadas: "",
	});
	const { handleDelete, handleSubmit } = useHandleActionItem();

	// Función para convertir datos traducidos a campos originales
	const translateDataToOriginal = (translatedData) => {
		const fieldMapping = {
			"ID Vehículo": "idVehiculo",
			"Marca": "marca",
			"Modelo": "modelo",
			"Año": "año",
			"Precio Lista": "precioLista",
			"Tipo": "tipo",
			"Transmisión": "transmision",
			"Combustible": "combustible",
			"Motor": "motor",
			"Tracción": "traccion",
			"URL Foto": "urlFoto",
			"Colores Disponibles": "coloresDisponibles",
			"Características Destacadas": "caracteristicasDestacadas"
		};

		const originalData = {};
		for (const [translatedKey, value] of Object.entries(translatedData)) {
			const originalKey = fieldMapping[translatedKey] || translatedKey;
			originalData[originalKey] = value;
		}
		return originalData;
	};

	useEffect(() => {
		if (locationType === "edit" && data) {
			const originalData = translateDataToOriginal(data);
			setVehicle(originalData);
		}
	}, [locationType, data]);

	const validateForm = () => {
		if (!vehicle.marca || !vehicle.modelo || !vehicle.año || !vehicle.precioLista) {
			Toast.fire({
				icon: "error",
				title: "Los campos obligatorios no pueden estar vacíos",
				background: "#1e2836",
			});
			return false;
		}
		return true;
	};

	const handleInputChange = (field, value) => {
		setVehicle((prev) => ({ ...prev, [field]: value }));
	};

	const handleSubmitForm = async (event) => {
		event.preventDefault();
		if (!validateForm()) return;
		try {
			if (locationType === "add") {
				await handleSubmit("add", "vehicles", vehicle);
			} else {
				await handleSubmit("update", "vehicles", vehicle);
			}
			navigate("/vehicles");
		} catch (error) {
			console.log("ERROR", error);
		}
	};

	const handleDeleteForm = async (event) => {
		event.preventDefault();
		await handleDelete({ idVehiculo: vehicle.idVehiculo }, "vehicles", true);
	};

	return (
		<div>
			<form onSubmit={handleSubmitForm}>
				<h1 className="text-center">{locationType === "add" ? "Agregar Vehículo" : "Actualizar Vehículo"}</h1>
				<InputText label="Marca" value={vehicle.marca || ""} setValue={(v) => handleInputChange("marca", v)} />
				<InputText label="Modelo" value={vehicle.modelo || ""} setValue={(v) => handleInputChange("modelo", v)} />
				<InputText label="Año" value={vehicle.año || ""} setValue={(v) => handleInputChange("año", v)} />
				<InputText label="Precio Lista" value={vehicle.precioLista || ""} setValue={(v) => handleInputChange("precioLista", v)} />
				<InputText label="Tipo" value={vehicle.tipo || ""} setValue={(v) => handleInputChange("tipo", v)} />
				<InputText label="Transmisión" value={vehicle.transmision || ""} setValue={(v) => handleInputChange("transmision", v)} />
				<InputText label="Combustible" value={vehicle.combustible || ""} setValue={(v) => handleInputChange("combustible", v)} />
				<InputText label="Motor" value={vehicle.motor || ""} setValue={(v) => handleInputChange("motor", v)} />
				<InputText label="Tracción" value={vehicle.traccion || ""} setValue={(v) => handleInputChange("traccion", v)} />
				<InputText label="URL Foto" value={vehicle.urlFoto || ""} setValue={(v) => handleInputChange("urlFoto", v)} />
				<InputText
					label="Colores Disponibles"
					value={vehicle.coloresDisponibles || ""}
					setValue={(v) => handleInputChange("coloresDisponibles", v)}
				/>
				<InputText
					label="Características Destacadas"
					value={vehicle.caracteristicasDestacadas || ""}
					setValue={(v) => handleInputChange("caracteristicasDestacadas", v)}
				/>
				<hr />
				<div className="mb-3 d-flex justify-content-around ">
					<button type="submit" className="btn btn-outline-theme btn-lg">
						{locationType === "add" ? "Agregar" : "Actualizar"}
					</button>
					<button onClick={() => navigate("/vehicles")} className="btn btn-outline-theme btn-lg">
						Atrás
					</button>
					{locationType === "edit" && (
						<button onClick={handleDeleteForm} className="btn btn-outline-danger btn-lg">
							Eliminar
						</button>
					)}
				</div>
			</form>
		</div>
	);
}

export default VehiclesDetails;
